import api from './api';
import { selfEncryptKey, selfDecryptKey, bufferToBase64, base64ToBuffer } from './signalCrypto';

const _saved = new Set(); // évite les PUT en double pendant la session

/** Renvoie la clé AES en clair si une enveloppe self existe et s'ouvre, sinon null. */
export async function openSelfWrap(container, currentUserId) {
  const w = container?.selfWraps?.find(x => String(x.userId) === String(currentUserId));
  if (!w) return null;
  try {
    const key = await selfDecryptKey(base64ToBuffer(w.key), base64ToBuffer(w.iv));
    return key.byteLength === 32 ? key : null;
  } catch {
    return null; // enveloppe faite avec une autre identité : on retombe sur Signal
  }
}

/** Sauvegarde la clé AES enveloppée pour soi-même. Non bloquant. */
export async function saveSelfWrap(url, aesKey) {
  if (aesKey?.byteLength !== 32) return;
  const dedupeKey = `${url}|${Array.from(aesKey.slice(0, 8)).join('.')}`;   // URL + empreinte de la clé
  if (_saved.has(dedupeKey)) return;
  _saved.add(dedupeKey);
  try {
    const { encrypted, iv } = await selfEncryptKey(aesKey);
    await api.put(url, { key: bufferToBase64(encrypted), iv: bufferToBase64(iv) });
  } catch (err) {
    _saved.delete(dedupeKey);
    console.error('⚠️ selfWrap non sauvegardé :', url, err.message);
  }
}
